import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, TextInput } from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const ChooseOne = ({ options = [], onSelect, defaultAnswer = null, isCustom = false }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOther, setOtherAnswer] = useState(false);
  const [other, setOtherText] = useState('')
  const handleSelect = (option) => {
    setSelectedOption(option);
    if (onSelect) {
      onSelect(option);
    }
    setOtherAnswer(false);
  };

  useEffect(() => {
    if (defaultAnswer && defaultAnswer.values) {
      for (let i of options) {
        if (i.label === defaultAnswer.values[0]) {
          setSelectedOption(defaultAnswer.values[0])
          return;
        }
      }
      setOtherText(defaultAnswer.values[0]);
      setOtherAnswer(true);

    }
  }, [])

  const onChangeText = (text) => {
    setSelectedOption(text);
    setOtherText(text);
    if (onSelect) {
      onSelect(text);
    }
  }

  const ClearText = () => {
    setOtherText('');
  }

  return (
    <View style={styles.container}>
      {options.map((option, index) => (
        <TouchableOpacity
          key={index}
          style={styles.optionContainer}
          onPress={() => handleSelect(option.label)}
        >
          <View style={[styles.radioCircle, { borderColor: selectedOption === option.label ? '#F65D79' : '#000000' }]}>
            {
              selectedOption !== option.label ? null : (<View style={styles.innerCircle}></View>)
            }
          </View>
          <Text style={styles.optionText}>{option.label}</Text>
        </TouchableOpacity>
      ))}
      <View>
        {
          isCustom ? (
            <View
              style={styles.optionContainer}
            >
              <TouchableOpacity onPress={() => {
                if (!isOther) {
                  setSelectedOption(other);
                  ClearText();
                }
                setOtherAnswer(!isOther)
              }
              }>
                <View style={[styles.radioCircle, { borderColor: isOther ? '#F65D79' : '#000000' }]}>
                  {
                    !isOther ? null : (<View style={styles.innerCircle}></View>)
                  }
                </View>
              </TouchableOpacity>
              <TextInput style={styles.inputCustomeChoice}
                value={other}
                onChangeText={(text) => {
                  onChangeText(text)
                }}
                onFocus={() => {
                  setSelectedOption('');
                  setOtherAnswer(true);
                }}
                autoFocus={false}
                placeholder='Nếu chọn "Khác", vui lòng ghi rõ'
                placeholderTextColor={'#666666'}
                maxLength={255}
              ></TextInput>
            </View>
          ) : null
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 16,
  },
  optionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10
  },
  radioCircle: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  optionText: {
    fontSize: 14,
    color: '#333333',
    fontFamily: FONT_STYLE.MEDIUM
  },
  innerCircle: {
    height: 12,
    width: 12,
    borderRadius: 10,
    backgroundColor: '#F65D79',
  },
  customeChoiceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
  },
  inputCustomeChoice: {
    height: 56,
    width: '100%',
    padding: 10,
    borderRadius: 10,
    borderColor: '#444444',
    borderWidth: 1,
    textAlignVertical: 'center',
    fontFamily: FONT_STYLE.MEDIUM,
    fontSize: 14
  }
});

export default ChooseOne;
